module.exports = __webpack_public_path__ + "static/img/DR_LAKRA.9e344de.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/DR_LAKRA.jpg
// module id = 9I0h
// module chunks = 1